import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { loadTimezone } from './utils/timezone'
import './styles/asset-flow-theme.css'

document.documentElement.setAttribute('data-theme', 'dark')
document.body.setAttribute('data-theme', 'dark')

async function bootstrap() {
  await loadTimezone()
  const app = createApp(App)
  app.use(router)
  app.use(i18n)
  app.mount('#app')
}
bootstrap()

// 隐藏loading遮罩，不依赖 window.load（图片等资源加载慢会导致永久卡住）
function hideLoadingMask() {
  const loadingMask = document.getElementById('loading-mask')
  if (!loadingMask || loadingMask.style.display === 'none') return
  loadingMask.style.opacity = '0'
  setTimeout(() => {
    loadingMask.style.display = 'none'
  }, 350)
}

// Vue mount 完成后 400ms 隐藏（正常路径）
setTimeout(hideLoadingMask, 400)

// 兜底：最多等 5 秒，无论如何都要隐藏
setTimeout(hideLoadingMask, 5000)